// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3xHgD","emails":"CreateEditClinics_emails__1H9c-","emailTagLabel":"CreateEditClinics_emailTagLabel__1XiuL"};